import styled from "styled-components";

const StyledContainer = styled.div`
  article {
    border-bottom: 1px solid rgba(201, 200, 200, 0.5);
    display: flex;
    gap: 44px;
    padding: 32px;

    h4 {
      color: #1e1919;
      font-size: 16px;
      margin: unset;
      width: 176px;
    }

    .container-content {
      border: 1px solid #c9c8c8;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      gap: 24px;
      padding: 16px;
      width: 600px;

      header {
        align-items: center;
        border: unset;
        background: #f0f2f5;
        border-radius: 8px;
        display: flex;
        font-weight: 500;
        justify-content: space-between;
        padding: 8px 16px;

        h5 {
          color: #1e1919;
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          margin: unset;
        }
      }
    }

    .ant-form-item {
      margin-bottom: unset;
    }

    .ant-input-number {
      width: 170px;
    }

    iframe {
      border-radius: 12px;
    }
  }
`;

export default StyledContainer;
